import { render, staticRenderFns } from "./LxChangeLocation.vue?vue&type=template&id=04b6cc11&scoped=true"
import script from "./LxChangeLocation.vue?vue&type=script&lang=js"
export * from "./LxChangeLocation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04b6cc11",
  null
  
)

export default component.exports